import React, { useState, useEffect } from 'react';
import { Form, Field } from 'react-final-form';
import propTypes from 'prop-types';
import { UiTable, UiSpacer } from 'src/ui';
;
import { Button, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;;
import { UiCheckboxAdapter } from '../../ui';
/* eslint-disable no-restricted-syntax */
export const ComplianceNotificationsTable = ({ data, updateNotifications }) => {
  const [initialValues, setInitialValues] = useState({});
  const [handleChange, setHandleChange] = useState(false);

  const buildInitialValues = () => {
    const newData = {};
    data.forEach(e => {
      newData[`notifyOnFail_${e.id}`] = e.notifyOnFail;
      newData[`notifyOnPass_${e.id}`] = e.notifyOnPass;
      newData[`notifyOnReview_${e.id}`] = e.notifyOnReview;
    });
    setInitialValues(newData);
  };
  useEffect(() => {
    buildInitialValues();
  }, [data]);

  const getDifference = (a, b) =>
    Object.fromEntries(
      Object.entries(b).filter(([key, val]) => key in a && a[key] !== val)
    );

  const onSubmit = async e => {
    const result = getDifference(initialValues, e);
    const newData = {};
    for (const [key, val] of Object.entries(result)) {
      const setting = key.slice(0, key.lastIndexOf('_'));
      const id = key.slice(key.lastIndexOf('_') + 1);

      if (!newData[id]) {
        newData[id] = {};
      }
      newData[id][setting] = val;
    }
    updateNotifications(newData);
  };

  const tableColumns = [
    {
      Header: 'Account',
      accessor: 'account',

      filterMethod: (_filter, row) => {
        return [row._original.account].some(v =>
          v.toLowerCase().includes(_filter.value.toLowerCase())
        );
      },
      Cell: row => <div className="account-name">{row.original.account}</div>,
      width: 250,
    },
    {
      Header: 'Task Type',
      accessor: 'type',
      filterMethod: (_filter, row) => {
        return [row._original.type].some(v =>
          v.toLowerCase().includes(_filter.value.toLowerCase())
        );
      },
      Cell: row => (
        <div className="has-text-grey-medium-dark">{row.original.type}</div>
      ),
    },
    {
      Header: 'Task Frequency',
      accessor: 'frequency',
      filterMethod: (_filter, row) => {
        return [row._original.frequency].some(v =>
          v.toLowerCase().includes(_filter.value.toLowerCase())
        );
      },
      Cell: row => (
        <div className="has-text-grey-medium-dark">
          {row.original.frequency}
        </div>
      ),
    },
    {
      Header: 'Fail',
      accessor: 'notifyOnFail',
      filterable: false,
      width: 70,
      resizable: false,
      Cell: row => (
        <Field
          component={UiCheckboxAdapter}
          id={`notifyOnFail_${row.original.id}`}
          name={`notifyOnFail_${row.original.id}`}
          type="checkbox"
          initialValue={row.original.notifyOnFail}
          label=""
          //   disabled={deleteArr.includes(row.original.id)}
        />
      ),
    },
    {
      Header: 'Pass',
      accessor: 'notifyOnPass',
      filterable: false,
      width: 70,
      resizable: false,
      Cell: row => (
        <div className="has-text-grey-medium-dark">
          <Field
            component={UiCheckboxAdapter}
            id={`notifyOnPass_${row.original.id}`}
            name={`notifyOnPass_${row.original.id}`}
            type="checkbox"
            defaultValue={row.original.notifyOnPass}
            label=""
            // disabled={deleteArr.includes(row.original.id)}
          />
        </div>
      ),
    },
    {
      Header: 'Review',
      accessor: 'notifyOnReview',
      filterable: false,
      width: 70,
      resizable: false,
      Cell: row => (
        <div className="has-text-grey-medium-dark">
          <Field
            component={UiCheckboxAdapter}
            id={`notifyOnReview_${row.original.id}`}
            name={`notifyOnReview_${row.original.id}`}
            type="checkbox"
            defaultValue={row.original.notifyOnReview}
            label=""
            // disabled={deleteArr.includes(row.original.id)}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => {
          return (
            <>
              <form
                onSubmit={handleSubmit}
                onChange={() => setHandleChange(true)}
              >
                <Columns>
                  <Column isSize="1/2">
                    <MuiTitle isSize="4" hasTextColor="info" tag="h2">
                      Notification Settings
                    </MuiTitle>
                  </Column>
                  <Column isSize="1/2" hasTextAlign="right">
                    <Button
                      isColor="gradient-bright"
                      type="submit"
                      disabled={!handleChange}
                    >
                      Submit
                    </Button>
                  </Column>
                </Columns>
                <UiSpacer />
                <UiTable
                  className="people-table -highlight"
                  isAlign="right"
                  columns={tableColumns}
                  data={data}
                  useTablePagination
                  title="Emails"
                  resolveData={data =>
                    data?.map(transaction => ({
                      ...transaction,
                    }))
                  }
                  hidePrev
                  hideNext
                  hideButton
                  filterable
                  pageSize={10}
                />
              </form>
            </>
          );
        }}
      />
    </>
  );
};

ComplianceNotificationsTable.propTypes = {
  data: propTypes.array.isRequired,
  updateNotifications: propTypes.func.isRequired,
};
